import React from 'react'
import clsx from 'clsx'
import coursesImage from '../img/courses-01.png'
import searchIcon from '../img/icons/search.svg'
import {ImgFilters} from '../components/ImgFilters'
import {Typography} from '../components/Typography'
import {Input} from '../components/Input'
import {Tag} from '../components/Tag'
import {BlogCard} from '../components/BlogCard'
import {useBlogQuery} from '../utils/hooks/useBlogQuery'
import {useBlogTagsQuery} from '../utils/hooks/useBlogTagsQuery'

export const Hero = ({className, imgDesktop, imgMobile}) => {
  const style = clsx(`relative w-full h-40 mb-4`, className)
  return (
    <div className={style}>
      <ImgFilters img={imgMobile} transparency className="lg:hidden" />
      <ImgFilters img={imgDesktop} transparency className="hidden lg:block" />
    </div>
  )
}

const Articles = ({articles}) => {
  return (
    <div className="flex flex-col justify-center">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {articles.map(article => (
          <BlogCard key={article.slug} {...article} />
        ))}
      </div>
    </div>
  )
}

export const BlogListPageTemplate = ({heroBanner}) => {
  const articles = useBlogQuery()
  const tags = useBlogTagsQuery()

  const [selectedTag, setSelectedTag] = React.useState('')
  const [searchText, setSearchText] = React.useState('')
  const [filterArticles, setFilterArticles] = React.useState(articles)

  const handleSelectTag = React.useCallback(
    tag => () => {
      setSelectedTag(tag)
    },
    [],
  )

  const changeSearchText = React.useCallback(ev => {
    setSearchText(ev.target.value)
  }, [])

  React.useEffect(() => {
    if (searchText === '') {
      setFilterArticles(articles)
    } else {
      const filter = articles.filter(article => {
        const {author = '', title = '', blogTags = []} = article
        const search = [author, title, ...(blogTags || [])]
          .map(item => item.toLowerCase())
          .join('')

        return search.includes(searchText.toLowerCase())
      })
      setFilterArticles(filter)
    }
  }, [searchText])

  React.useEffect(() => {
    if (selectedTag !== '') {
      setFilterArticles(
        articles.filter(a => (a.blogTags || []).includes(selectedTag)),
      )
    } else {
      setFilterArticles(articles)
    }
  }, [selectedTag])

  return (
    <div>
      <Hero {...heroBanner} />
      <div className="flex p-4 lg:px-32 space-x-4">
        <Articles articles={filterArticles} />
        <div className="p-4 shadow-lg w-60 space-y-3">
          <div className="mb-6 space-y-4">
            <Typography className="text-center uppercase" weight="black">
              Pesquise aqui
            </Typography>

            <div className="flex">
              <Input
                fullWidth
                type="text"
                placeholder="Procure um artigo!"
                rounded="rounded-l"
                onChange={changeSearchText}
                value={searchText}
                className="border border-r-0 border-gray-100"
              />
              <button type="button" className="pl-2 pr-1 bg-gray-100 rounded-r">
                <img src={searchIcon} alt="" />
              </button>
            </div>
          </div>
          <Typography className="text-center uppercase" weight="black">
            Ou Filtre pelas tags:
          </Typography>
          <ul className="flex flex-col space-y-3">
            <Tag as="li" className="text-center" variant="gray">
              <button
                type="button"
                className="w-full h-full focus:outline-none"
                onClick={handleSelectTag('')}
              >
                Todas
              </button>
            </Tag>
            {tags.map(tag => (
              <Tag as="li" key={tag} className="text-center" variant="gray">
                <button
                  type="button"
                  className="w-full h-full focus:outline-none"
                  onClick={handleSelectTag(tag)}
                >
                  {tag}
                </button>
              </Tag>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

const Template = ({pageContext}) => {
  return <BlogListPageTemplate {...pageContext?.frontmatter} />
}

export default Template
